import AreaContainer from "../AreaContainer";
import Feature from "./Feature";
import styles from './featutes.module.css';
import TEXT from "localisation";

interface Props {
  size: number;
  use_class: string;
  for_sale: boolean | number;
  rent: number;
  price: number;
  annual_footfall: string;
  is_scheme: boolean;
  britishLandLayout: boolean;
  category_code: string;
}

const Features = ({ size, use_class, for_sale, rent, price, annual_footfall, is_scheme, britishLandLayout = false, category_code, owners }: Props) => {
  return (
    <AreaContainer area="features" style={null} extraClass={null}>
      <div className={`${styles.FeatureWrapper}`}>
        {use_class && <Feature icon="badge-useclass-grey" label="Use Class" value={use_class} />}
        {Boolean(size) && (
          <Feature icon="badge-size-grey" label="Size" value={`${size.toLocaleString()} sq ft`} />
        )}
        {!for_sale && !is_scheme && (
          <Feature icon="badge-rent-grey" label="Rent pa" value={!rent ? "POA" : `£${rent.toLocaleString()}`} />
        )} 
        {(Boolean(price) && price !== 0) && (
          <Feature
            icon="badge-rent-grey"
            label="Price"
            value={!Number.isNaN(parseInt(String(price), 10)) ? `£${price.toLocaleString()}` : price.toLocaleString(undefined, { minimumFractionDigits: 0 })}
          />
        )}
        {(Boolean(for_sale) && price === 0) && (
          <Feature
            icon="badge-rent-grey"
            label="Price"
            value={'POA'}
          />
        )}
        { Boolean(annual_footfall) && price !== 0 && (
          <Feature icon="badge-footfall-grey" label="Footfall pa" value={
            RegExp(/^[0-9]+$/).exec(annual_footfall) != null ? Number(annual_footfall).toLocaleString() : annual_footfall
          } />
        )}
        {category_code && <Feature icon='shopping-centre' label="Market Sector" value={TEXT[`SCHEME_${category_code}_LABEL_UPPER_SINGLE`]} />}
        {
          owners && owners.length > 0 && <Feature icon='agent' label="Landlord" value={owners[0].company_name} />
        }
      </div>
    </AreaContainer>
  );
};

export default Features;
